export default __webpack_public_path__ + "static/washi-background-72fffc35660c253d484ffbf7b08278cb.png";